// MB.6 — illagers. PURE (ENG-1). The evoker's vex-summon cadence and cap; the
// host casts on this schedule during the evoker's AI (in-world summon wiring is
// a remainder — the evoker fights as a melee raider today). Kept here so the
// numbers are pinned and testable.

export const VEX_SUMMON_COOLDOWN = 100; // gt between casts (5 s)
export const VEX_SUMMON_COUNT = 3;      // vexes conjured per cast
export const VEX_MAX_NEARBY = 7;        // stop summoning past this many live vexes

/** Time for an evoker to cast, and room under the vex cap for more. */
export function canSummonVexes(cooldownRemaining: number, nearbyVexes: number): boolean {
  return cooldownRemaining <= 0 && nearbyVexes < VEX_MAX_NEARBY;
}

/** How many vexes a cast conjures, never exceeding the nearby cap. */
export function vexesToSummon(nearbyVexes: number): number {
  return Math.max(0, Math.min(VEX_SUMMON_COUNT, VEX_MAX_NEARBY - Math.max(0, nearbyVexes)));
}
